import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { CatalogCreatePage } from '@/features/data/catalog/catalog-create-page';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/catalog/$layer/$database/new')({ component: NewTableRoute });

function NewTableRoute() {
  const { tenant, layer, database } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="catalog"
      crumbs={[
        { label: t('nav.items.catalog') },
        { label: layer, mono: true },
        { label: database, mono: true },
        { label: t('data.catalog.new.table') },
      ]}
    >
      <CatalogCreatePage tenantId={tenant} parent={{ level: 'database', layer, database }} />
    </ConsoleShell>
  );
}
